import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource } from '@atlassian/react-resource-router';
import { fetchDefaultPINFiltersNavData } from '../../../services/sidebar/project-filters/main.tsx';
import type { DefaultPINFeatures as DefaultPinFeatures } from '../../../services/sidebar/project-filters/types.tsx';

export const staticSidebarDefaultPINFiltersResource = createResource<DefaultPinFeatures | null>({
	type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
	getKey: ({ match, query }) => {
		const { projectKey } = getProjectKeyId(match, query);
		return projectKey || 'none';
	},
	getData: async ({ match, query }) => {
		const { projectKey } = getProjectKeyId(match, query);
		if (projectKey == null) {
			return null;
		}
		return fetchDefaultPINFiltersNavData(projectKey);
	},
	maxAge: 5 * 60 * 1000,
});
